import { render, staticRenderFns } from "./LineaTiempoObservaciones.vue?vue&type=template&id=0f596666&scoped=true"
import script from "./LineaTiempoObservaciones.vue?vue&type=script&lang=js"
export * from "./LineaTiempoObservaciones.vue?vue&type=script&lang=js"
import style0 from "./LineaTiempoObservaciones.vue?vue&type=style&index=0&id=0f596666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f596666",
  null
  
)

export default component.exports